<template>
  <div class="weui-cell weui-cell_uploader">
    <div class="weui-cell__bd">
      <div class="weui-uploader">
        <div class="weui-uploader__hd">
          <p class="weui-uploader__title">{{label}}</p>
          <div class="weui-uploader__info">{{files.length}}/{{maxSize}}</div>
        </div>
        <div class="weui-uploader__bd">
          <div class="file-list" :class="{'weui-cells':maxSize>1}">
            <div class="weui-cell" v-for="(file,xindex) in files" :key="file.id">
              <div class="weui-cell__hd" @click="selected=file">
                <div class="file-thumb" v-if="file.type=='IMAGE'&&thumb">
                  <img :src="file.outUrl" />
                </div>
                <span v-else class="iconfont file-type__icon" :class="getIconByType(file)"></span>
              </div>
              <div class="weui-cell__bd" @click="selected=file">
                <p>{{file.name}}</p>
                <p class="list-item-muted">{{sizeFormat(file.size)}}</p>
              </div>
              <div class="weui-cell__ft">
                <a
                  target="_blank"
                  class="weui-cell__tool tool-download"
                  @click="download(file)"
                >下载</a>
                <a
                  href="javascript:;"
                  class="weui-cell__tool tool-remove"
                  @click="removeItem(file,xindex)"
                >
                  <span>删除</span>
                </a>
              </div>
            </div>
          </div>
          <div class="weui-uploader__input-box" v-show="files.length<maxSize">
            <input class="weui-uploader__input" type="file" @change="onSelectFile" :accept="accept" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="selected" @click="selected=null" class="weui-gallery">
      <span class="weui-gallery__img" :style="'background-image: url(' + selected.outUrl + ');'"></span>
      <span class="weui-gallery__text">点击图片关闭</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "附件"
    },
    /**
     * 最多能上传多少个附件
     */
    maxSize: {
      type: Number,
      default: 20
    },
    value: String,
    /**
     * 有些业务单据保存的附件ID（多个用分号分隔），有些是直接保存的附件path。
     * 使用value-property="path"来表示该字段使用附件path；
     * 使用value-property="id"来表示该字段使用附件ID，默认为该配置
     */
    valueProperty: {
      type: String,
      default: "id"
    },
    /**
     * 如果附件为图片，是否显示图片的缩略图
     */
    thumb: {
      type: Boolean,
      default: false
    },
    /**
     * 支持的附件类型
     */
    accept: {
      type: String,
      // default: "*/*"
      default: window.navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1 ? '.doc,.docx,.xlsx,.xls,.pdf,.ppt,.pptx,.txt,.mp3,.m4a,.zip,video/*,audio/*,image/*' : '*/*'
    }
  },
  data() {
    return {
      files: [],
      selected: null
    };
  },
  watch: {
    value() {
      // 单据read接口返回数据后，附件字段有值，则按字段值加载并显示具体附件信息
      var me = this,
        value = me.value;
      if (!me.firechange && value) {
        me.loadData();
      }
    }
  },
  methods: {
    loadData() {
      var me = this,
        value = me.value,
        isPath = me.valueProperty == "path",
        params = {};
      if (isPath) {
        params.path = value;
      } else {
        params.ids = value;
      }
      me.$ajax({
        url: "/api/file/info",
        params
      }).then(function(res) {
        if (res.success) {
          me.files = isPath ? [res.data] : res.data;
        }
      });
    },
    getIconByType(file) {
      var type = file.type,
        ext = file.ext;
      if (type != "DOC") {
        return {
          IMAGE: "icon-png",
          TEXT: "icon-txt",
          COMPRESS: "icon-zip",
          VIDEO: "icon-video",
          AUDIO: "icon-audio",
          OTHER: "icon-file"
        }[type];
      } else {
        return (
          {
            doc: "icon-word",
            docx: "icon-word",
            xls: "icon-excel",
            xlsx: "icon-excel",
            ppt: "icon-ppt",
            pptx: "icon-ppt"
          }[ext] || "icon-file"
        );
      }
    },
    /**
     * 删除文件
     */
    removeItem(file, index) {
      var me = this,
        value = me.value,
        items = [];
      me.$weui.confirm(`确定删除《${file.name}》？`, function() {
        if (me.valueProperty == "path") {
          value.split(";").forEach(item => {
            if (item && item != file.id) {
              items.push(item);
            }
          });
          if (items.length) {
            value = items.join(";") + ";";
          } else {
            value = '';
          }
        } else {
          value = value.replace(file.id + ";", "")
        }
        me.files.splice(index, 1);
        me.firechange = true;
        me.$emit("input", value);
      });
    },
    /**
     * 上传文件
     */
    onSelectFile(e) {
      var me = this,
        data = new FormData(),
        files = e.target.files,
        value;
      if (!files.length) {
        return;
      }
      data.append("file", files[0]);
      me.$loading({
        url: "/api/file/upload",
        method: "POST",
        rawData: data
      })
        .then(function(res) {
          if (res.success) {
            me.files.push(res.data);
            me.firechange = true;
            if (me.valueProperty == "path") {
              value = res.data.fullPath;
            } else {
              value = (me.value || "") + res.data.id + ";";
            }
            me.$emit("input", value);
          } else {
            me.$weui.topTips("上传失败: " + res.message, 3000);
          }
        })
        .catch(function() {
          me.$weui.topTips("上传失败", 3000);
        });
    },
    /**
     * 从第三方平台url复制
     */
    setThirdUrlList(urlList) {
      var me = this, value;
      me.$loading({
        url: "/api/file/batch_copy",
        method: "POST",
        jsonData: urlList
      })
        .then(function(res) {
          if (res.success) {
            me.files = res.data;
            me.firechange = true;
            if (me.valueProperty == "path") {
              value = res.data[0].fullPath;
            } else {
              value = me.files.map(f => f.id).join(';') + ';';
            }
            me.$emit("input", value);
          } else {
            me.$weui.topTips("上传失败: " + res.message, 3000);
          }
        })
        .catch(function() {
          me.$weui.topTips("上传失败", 3000);
        });
    },
    download(file) {
      if (window.uni) {
        /**
         * uniapp环境，文件下载问题
         */
        window.uni.postMessage({
          data: {
            action: 'downloadFile',
            params: file
          }
        })
      } else {
        let a = document.createElement('a')
        a.href = file.outUrl
        a.click()
      }
    }
  }
};
</script>

<style scoped>
.tool-download {
  color: var(--weui-LINK);
}
.tool-remove {
  color: #888;
}
.weui-gallery {
  display: block;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.weui-gallery__text {
  position: fixed;
  bottom: calc(10px + env(safe-area-inset-bottom));
  left: 0;
  right: 0;
  text-align: center;
  color: #fff;
}
</style>